import { IContact } from '@cemex-core/cmx-api';
import {
  OneClickReceivingPersonsActions,
  OneClickReceivingPeopleActionTypes,
} from '@ordersnproducts/modules/one-click-order/actions/one-click-receiving-persons.actions';

export interface OneClickReceivingPersonState {
  loading: boolean;
  receivingPeopleAvailable: IContact[];
  selected: IContact;
}

export const initialState: OneClickReceivingPersonState = {
  loading: false,
  receivingPeopleAvailable: [],
  selected: null,
};

export function reducer(state = initialState, action: OneClickReceivingPersonsActions): OneClickReceivingPersonState {
  switch (action.type) {
    case OneClickReceivingPeopleActionTypes.LOAD_RECEIVING_PEOPLE: {
      return {
        ...state,
        loading: true,
      } as OneClickReceivingPersonState;
    }
    case OneClickReceivingPeopleActionTypes.LOAD_RECEIVING_PEOPLE_COMPLETE: {
      return {
        ...state,
        loading: false,
        receivingPeopleAvailable: [...action.payload],
      } as OneClickReceivingPersonState;
    }
    case OneClickReceivingPeopleActionTypes.SELECT_RECEIVING_PERSON: {
      return {
        ...state,
        selected: action.payload,
      } as OneClickReceivingPersonState;
    }
    case OneClickReceivingPeopleActionTypes.LOAD_RECEIVING_PEOPLE_ERROR:
    case OneClickReceivingPeopleActionTypes.RESET: {
      return {
        ...initialState,
      };
    }
    default: {
      return state;
    }
  }
}
